module.exports = __webpack_public_path__ + "media/images/home/illustration_main-48e9b0ba52acca07ec688c8c3fcec0fa.svg";